export const environment = {
  "production": false,
  "PEOPLE_CLOUD_APP_URL": "https://dev2-api.kenjo.io",
  "ORGOS_WEB_APP_URL": "https://dev2-env.kenjo.io",
  "delay": "false",
  "AMPLITUDE_IGNORE_DOMAINS": " ",
  "AMPLITUDE_API_KEY": "386da99b232512c0fc98ea00489374da",
  "SENTRY_DSN": "https://338de8d5709986bfbaef35c7e5c48bab@o4509275823079424.ingest.de.sentry.io/4509276251291728",
  "SLUG_COMMIT_AWS": "<<SLUG_COMMIT>>",
  "APP_NAME_AWS": "staging",
  "ENABLE_ERRORS_BY_CONSOLE": "false"
};